import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Carousel } from 'components/Carousel/Carousel'

import Styles from './BestPerformingPostsCarouselSection.module.scss'

import {
  BestPerformingPlatformPost,
  useAllBestPerformingPlatformPosts,
} from 'hooks/queries/useAllBestPerformingPlatformPosts'
import { useModals } from 'almanac-ui/Modal'
import { RecommendMoreContentWizard } from 'components/Wizards/RecommendMoreContentWizard/RecommendMoreContentWizard'
import { PostPreview } from 'screens/Analytics/BestPerformingPlatformPosts/components/PostPreview/PostPreview'

export const BestPerformingPostsCarouselSection = ({
  isHome = false,
  isForYou = false,
}: {
  isHome?: boolean
  isForYou?: boolean
}) => {
  const { data, isLoading } = useAllBestPerformingPlatformPosts()
  const { openModal } = useModals()

  if (isLoading || (data?.best_performing_platform_posts || []).length === 0) return null

  const handleClick = (post: BestPerformingPlatformPost) => {
    openModal(RecommendMoreContentWizard, {
      postId: post.id,
      topic: post.topic,
      externalIntegrationId: post.external_integration.id,
    })
  }

  return (
    <div className={Styles.container} data-testid="container">
      {isHome && (
        <div className={Styles.header}>
          <Heading level={3}>Your Best Performing Posts</Heading>
          <Text variant="placeholder" color="var(--dark-60)">
            Click to create more of them
          </Text>
        </div>
      )}
      {isForYou && (
        <div className={Styles.header}>
          <Heading level={3}>Generate more content like your best posts</Heading>
        </div>
      )}
      <div className={Styles.carousel}>
        <Carousel offset={0} withControls={false}>
          {data?.best_performing_platform_posts.map((post, i) => {
            return (
              <div key={post.id} className={Styles.postContainer} onClick={() => handleClick(post)}>
                <Text>
                  <div className={Styles.popularRank}>{i + 1}</div>
                </Text>
                <div className={Styles.post}>
                  <PostPreview post={post} externalIntegrationId={post.external_integration.id} />
                </div>
              </div>
            )
          })}
        </Carousel>
      </div>
    </div>
  )
}
